import { render, staticRenderFns } from "./CreateEditDoctorAdmin.vue?vue&type=template&id=67587628&scoped=true&"
import script from "./CreateEditDoctorAdmin.vue?vue&type=script&lang=ts&"
export * from "./CreateEditDoctorAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditDoctorAdmin.vue?vue&type=style&index=0&id=67587628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67587628",
  null
  
)

export default component.exports